(ns com.github.tamaikisage.arzulari-yogunlashtir.app
  (:require [com.github.tamaikisage.arzulari-yogunlashtir.routes :refer [most-routes not-found]]
            [com.github.tamaikisage.arzulari-yogunlashtir.components :refer [navigation-menu]]
            [com.github.tamaikisage.arzulari-yogunlashtir.lib :refer [deep-equals]]
            [com.github.tamaikisage.arzulari-yogunlashtir.browser-data :refer [current-route]]
            [reagent.dom.client :as rdom]
            [reitit.frontend :as rf]
            [reitit.frontend.easy :as rfe]))

(add-watch current-route :scroll-to-top
           (fn [_ _ old-state new-state]
             (when (not= (get-in old-state [:data :name])
                         (get-in new-state [:data :name]))
               (.scrollTo js/window 0 0))))

(defn- root-component []
  [:div.site
   [:div.site-content
    [:header.site-header
     [:h1 "The Eternal Vow of İntensification"]
     [navigation-menu most-routes]]
    [:hr.divider]
    (if-let [view (get-in @current-route [:data :view])]
      [:main.main-content [view]]
      not-found)]])

(defonce root (rdom/create-root (.getElementById js/document "app")))

(defn render []
  (rdom/render root [root-component]))

(defn init-routes! []
  (rfe/start!
   (rf/router most-routes)
   (fn [new-match] (reset! current-route new-match))
   {:use-fragment false}))

(defn init []
  (init-routes!)
  (render))

;; Mainly for cleanup
(defn ^:before-load pre-reload []
  (js/console.log "We're about to reload. This is the right time to stop timers, and do other clean ups"))

(defn get-current-path []
  (let [hash (.. js/window -location -hash)
        path (.. js/window -location -pathname)]
    (if (and hash (not= hash ""))
      ;; Remove the leading '#' to get the internal route
      (.substring hash 1)
      ;; Fallback to standard pathname
      path)))

(defn ^:after-load reload []
  (let [router (rf/router most-routes)
        path (get-current-path)
        match (rf/match-by-path router path)]
    (when (deep-equals [:data :name] @current-route match)
      (reset! current-route match)))
  (render))